/**
 * quill-color-picker-enhance bundles Quill 1.x tooltip code that reads
 * `quill.scrollingContainer.scrollTop`. Quill 2 removed scrollingContainer,
 * which breaks link save/remove in the enhanced snow theme.
 */
export function patchQuillScrollingContainer(quill: {
  root?: HTMLElement;
  scrollingContainer?: HTMLElement;
}): void {
  if (!quill?.root || quill.scrollingContainer) {
    return;
  }

  let parent: HTMLElement | null = quill.root.parentElement;
  while (parent) {
    const { overflowY } = window.getComputedStyle(parent);
    if (overflowY === "auto" || overflowY === "scroll") {
      quill.scrollingContainer = parent;
      return;
    }
    parent = parent.parentElement;
  }

  quill.scrollingContainer = quill.root;
}
